import { useCallback, useRef } from 'react';

type FunctionType = (...args: any[]) => any;

export const useThrottle = (
  fn: FunctionType,
  wait: number,
  option = { leading: true, trailing: false }
) => {
  const timerId = useRef<any>(); // track the timer
  const lastArgs = useRef<any>(); // track the args

  // create a memoized debounce
  const throttle = useCallback(
    function (this: ThisParameterType<FunctionType>, ...args: Parameters<FunctionType>) {
      const { trailing, leading } = option;
      // function for delayed call
      const waitFunc = () => {
        // if trailing invoke the function and start the timer again
        if (trailing && lastArgs.current) {
          //@ts-ignore
          fn.apply(this, lastArgs.current);
          lastArgs.current = null;
          timerId.current = setTimeout(waitFunc, wait);
        } else {
          // else reset the timer
          timerId.current = null;
        }
      };

      // if leading run it right away
      if (!timerId.current && leading) {
        //@ts-ignore
        fn.apply(this, args);
      }
      // else store the args
      else {
        lastArgs.current = args;
      }

      // run the delayed call
      if (!timerId.current) {
        timerId.current = setTimeout(waitFunc, wait);
      }
    },
    [fn, wait, option]
  );

  return throttle;
};
